import { PlanType, TagType } from 'types';
import { SystemType } from 'types/system';

export interface SetVesselCategoriesReturn {
    type: string;
    payload: TagType[];
}

export interface SetVesselCategoriesAction {
    (vesselcategories: TagType[]): SetVesselCategoriesReturn;
}

export const setVesselCategoriesAction: SetVesselCategoriesAction = (vesselcategories) => {
    return {
        type: 'SET_VESSEL_CATEGORIES',
        payload: vesselcategories,
    };
};

// Return type for SetTagsAction
export interface SetTagsReturn {
    type: string;
    payload: TagType[];
}

export interface SetTagsAction {
    (tags: TagType[]): SetTagsReturn;
}

export const setTagsAction: SetTagsAction = (tags) => {
    return {
        type: 'SET_TAGS',
        payload: tags,
    };
};

// Return type for SetTagsAction
export interface SetDefaultDataReturn {
    type: string;
    payload: object;
}

export interface SetDefaultDataAction {
    (defaultData: object): SetDefaultDataReturn;
}

export const setDefaultDataAction: SetDefaultDataAction = (defaultData) => {
    return {
        type: 'SET_DEFAULT_DATA',
        payload: defaultData,
    };
};

// Return type for SetPilotagePlansAction
export interface SetPilotagePlansReturn {
    type: string;
    payload: PlanType[];
}

export interface SetPilotagePlansAction {
    (plans: PlanType[]): SetPilotagePlansReturn;
}

export const setPilotagePlansAction: SetPilotagePlansAction = (plans) => {
    return {
        type: 'SET_PILOTAGE_PLANS',
        payload: plans,
    };
};

// Return type for SetSystemAction
export interface SetSystemReturn {
    type: string;
    payload: SystemType;
}

export interface SetSystemAction {
    (system: SystemType): SetSystemReturn;
}

export const setSystemAction: SetSystemAction = (system) => {
    return {
        type: 'SET_SYSTEM',
        payload: system,
    };
};

// Return type for SetSystemUpdateAction
export interface SetSystemUpdateReturn {
    type: string;
    payload: any;
}

export interface SetSystemUpdateAction {
    (update: any): SetSystemUpdateReturn;
}

export const setSystemUpdateAction: SetSystemUpdateAction = (update) => {
    return {
        type: 'SET_SYSTEM_UPDATE',
        payload: update,
    };
};
